import { render, staticRenderFns } from "./FDProfileSetup.vue?vue&type=template&id=520a7090&scoped=true&"
import script from "./FDProfileSetup.vue?vue&type=script&lang=js&"
export * from "./FDProfileSetup.vue?vue&type=script&lang=js&"
import style0 from "./FDProfileSetup.vue?vue&type=style&index=0&id=520a7090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a7090",
  null
  
)

export default component.exports